<template>
  <div :class="['bg-white border rounded-xl p-4 shadow-sm', toneBorder]">
    <div class="flex items-center gap-3">
      <div :class="['p-2 rounded-lg', toneBg]">
        <component :is="icon" :class="['w-5 h-5', toneText]" />
      </div>
      <div class="min-w-0">
        <p class="text-2xl font-bold text-dashboard-text leading-none">{{ value }}</p>
        <p class="text-xs text-dashboard-muted mt-1 truncate">{{ label }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  label: string
  value: string
  icon: any
  tone?: 'slate' | 'amber' | 'red' | 'indigo' | 'emerald' | 'blue'
}>()

const TONES: Record<string, { bg: string; text: string; border: string }> = {
  slate:   { bg: 'bg-slate-50',   text: 'text-slate-600',   border: 'border-dashboard-border' },
  amber:   { bg: 'bg-amber-50',   text: 'text-amber-600',   border: 'border-amber-200' },
  red:     { bg: 'bg-red-50',     text: 'text-red-600',     border: 'border-red-200' },
  indigo:  { bg: 'bg-indigo-50',  text: 'text-indigo-600',  border: 'border-dashboard-border' },
  emerald: { bg: 'bg-emerald-50', text: 'text-emerald-600', border: 'border-dashboard-border' },
  blue:    { bg: 'bg-blue-50',    text: 'text-blue-600',    border: 'border-dashboard-border' },
}

const toneBg = computed(() => TONES[props.tone || 'slate'].bg)
const toneText = computed(() => TONES[props.tone || 'slate'].text)
const toneBorder = computed(() => TONES[props.tone || 'slate'].border)
</script>
